import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import { Link } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import GetProfile from "../../Api/Speakers/Profile/GetProfile";

const NewsDetail = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const { user, userId } = useAuth();
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const { newsId } = useParams();
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const { id } = useParams();
  console.log("news id", id);
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [activeFilter, setActiveFilter] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");
  const [userRole, setUserRole] = useState(null);
  const [shareMessage, setShareMessage] = useState("");

  // 1. جلب تفاصيل الخبر
  useEffect(() => {
    const fetchNewsDetail = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/users/news/${newsId}`
        );
        console.log(t("news.logDetails"), response.data);
        setNewsItem(response.data);
      } catch (error) {
        console.error(t("news.fetchError"), error);
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (newsId) fetchNewsDetail();
  }, [newsId]);

  // 2. جلب نص المشاركة
  useEffect(() => {
    const fetchShareMessage = async () => {
      try {
        const response = await fetch(`/api/v1/users/news/${newsId}/share`);
        const data = await response.json();
        setShareMessage(data.message);
      } catch (error) {
        console.error("Failed to fetch share message", error);
      }
    };

    if (newsId) fetchShareMessage();
  }, [newsId]);

  // 3. إرجاع واجهة المستخدم
  if (loading) return <p>{t("news.loading")}</p>;

  if (error)
    return (
      <div className="text-center text-danger mt-5">
        <h4>{t("news.loadErrorTitle")}</h4>
        <p>{error.message || t("news.loadErrorMessage")}</p>
      </div>
    );

  if (!newsItem) return <p>{t("news.noDetails")}</p>;

  // 4. منطق العرض ومشاركة الروابط
  const {
    title,
    description,
    createdOn,
    thumbnailImagePath,
    viewCount,
    newsType,
  } = newsItem;

  const shareOn = (platform) => {
    let shareUrl = "";
    const message = `${shareMessage}`;

    switch (platform) {
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          message
        )}`;
        break;
      case "whatsapp":
        shareUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          message
        )}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
          window.location.href
        )}&summary=${encodeURIComponent(message)}`;
        break;
      default:
        break;
    }

    if (shareUrl) {
      window.open(shareUrl, "_blank", "noopener,noreferrer");
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href);
    toast.success(t("news.linkCopied"));
  };

  return (
    <div dir={languageDirection}>
      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto">
              <div className="news-header mb-4">
                <div className="news-meta mb-3">
                  <span
                    className="badge"
                    style={{
                      backgroundColor: newsType?.color || "#3498db",
                      color: "#fff",
                    }}
                  >
                    {i18n.language === "ar"
                      ? newsType?.arabicName
                      : newsType?.englishName}
                  </span>

                  <small className="text-muted ms-3">
                    <i className="fas fa-calendar-alt me-1"></i>
                    {new Date(createdOn).toLocaleDateString(i18n.language)}
                  </small>
                  <small className="text-muted ms-3">
                    <i className="fas fa-eye me-1"></i>
                    {viewCount?.toLocaleString()} {t("news.views")}
                  </small>
                </div>
                <h1 className="display-5 mb-4">{title}</h1>
              </div>

              <div className="news-image mb-4">
                <img
                  src={thumbnailImagePath}
                  className="img-fluid rounded shadow"
                  alt={title}
                />
              </div>

              <div className="news-content">
                <div
                  className="lead"
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </div>
              {/* فسم المشاركة */}
              <div className="share-section mt-5 pt-4 border-top">
                <h5 className="mb-3">{t("news.share")}</h5>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => shareOn("twitter")}
                  >
                    <i className="fab fa-twitter me-1"></i> {t("news.twitter")}
                  </button>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => shareOn("whatsapp")}
                  >
                    <i className="fab fa-whatsapp me-1"></i>{" "}
                    {t("news.whatsapp")}
                  </button>
                  <button
                    className="btn btn-info btn-sm"
                    onClick={() => shareOn("linkedin")}
                  >
                    <i className="fab fa-linkedin me-1"></i>{" "}
                    {t("news.linkedin")}
                  </button>
                  <button
                    className="btn btn-secondary btn-sm"
                    onClick={copyLink}
                  >
                    <i className="fas fa-link me-1"></i> {t("news.copyLink")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </div>
  );
};

export default NewsDetail;
